import React from 'react';

import { LazyHeaderAndFooterPage } from '@confluence/site-settings/entry-points/HeaderAndFooterPage.ts';
import { ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/headerAndFooterConstants.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminHeaderAndFooterRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <LazyHeaderAndFooterPage />;

AdminHeaderAndFooterRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
